import { evaluate } from "mathjs";
import React, { useState } from "react";
import Boton from "./Boton";
import BotonClear from "./BotonClear";
import styles from "./calculdora.module.css";
import Pantalla from "./Pantalla";

const Calculadora = () => {
  const [valor, setValor] = useState("");

  const agregarValor = (val) => {
    setValor(valor + val);
  };

  const mostrarResultado = () => {
    if (valor) {
      setValor(evaluate(valor));
    } else {
      alert("Por favor ingresa un valor valido");
    }
  };

  return (
    <div className={styles.containerCal}>
      <Pantalla valor={valor} />
      <div className={styles.fila}>
        <Boton agregarValor={agregarValor}>7</Boton>
        <Boton agregarValor={agregarValor}>8</Boton>
        <Boton agregarValor={agregarValor}>9</Boton>
        <Boton agregarValor={agregarValor}>*</Boton>
      </div>
      <div className={styles.fila}>
        <Boton agregarValor={agregarValor}>4</Boton>
        <Boton agregarValor={agregarValor}>5</Boton>
        <Boton agregarValor={agregarValor}>6</Boton>
        <Boton agregarValor={agregarValor}>-</Boton>
      </div>
      <div className={styles.fila}>
        <Boton agregarValor={agregarValor}>1</Boton>
        <Boton agregarValor={agregarValor}>2</Boton>
        <Boton agregarValor={agregarValor}>3</Boton>
        <Boton agregarValor={agregarValor}>+</Boton>
      </div>
      <div className={styles.fila}>
        <Boton agregarValor={mostrarResultado}>=</Boton>
        <Boton agregarValor={agregarValor}>0</Boton>
        <Boton agregarValor={agregarValor}>.</Boton>
        <Boton agregarValor={agregarValor}>/</Boton>
      </div>
      <BotonClear setValor={setValor} />
    </div>
  );
};

export default Calculadora;
